import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const AvatarModal = ({ isOpen, toggle, avatarUrl, clienteName }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        Avatar - {clienteName || 'Cliente'}
      </ModalHeader>
      <ModalBody className="text-center">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={`Avatar de ${clienteName || 'cliente'}`}
            className="img-fluid"
            style={{ maxHeight: '500px', maxWidth: '100%' }}
            onError={(e) => {
              e.target.src = '/assets/images/users/avatar-1.jpg'; // Fallback image
            }}
          />
        ) : (
          <div className="text-muted">
            <i className="fas fa-user-circle fa-5x"></i>
            <p className="mt-3">No hay avatar disponible</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AvatarModal;
